// V1 Table - Re-export from seeds-react-table for optimal tree shaking
export {
  default as Table,
  Table as TableV1,
} from "@sproutsocial/seeds-react-table/v1";

// Explicit type exports
export type {
  TypeTableProps,
  TypeTableRow,
  TypeTableHeadProp,
  TypePassthroughProps,
} from "@sproutsocial/seeds-react-table/v1";
